export const PAGINATE_LIMIT = 15;
export const SORT_BY_FIELD = 'title';
export const FETCH_ERROR_MESSAGE = 'Could not fetch help bits';
